import React from 'react';
import { X } from 'lucide-react';

/** Shared modal shell for Admin panel dialogs. */
export default function AdminModal({ children, onClose, title, testId, wide }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div data-testid={testId} style={{ backgroundColor: '#FFF', borderRadius: 20, padding: 28, maxWidth: wide ? 640 : 420, width: '100%', position: 'relative', maxHeight: '90vh', overflowY: 'auto' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} color="#5C6B73" /></button>
        <h3 style={{ fontSize: 20, fontWeight: 800, color: '#2F3E46', fontFamily: 'Outfit, sans-serif', marginBottom: 20 }}>{title}</h3>
        {children}
      </div>
    </div>
  );
}

export const adminInputStyle = { width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #E2DAC8', fontSize: 14, color: '#2F3E46', backgroundColor: '#FFF' };
export const adminLabelStyle = { fontSize: 13, fontWeight: 600, color: '#5C6B73', display: 'block', marginBottom: 4 };
